//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import payforList from "../../component/payforList/index";
import goodInfo from "../../component/goodInfo/index";
import httpApi from "../../api/cashier";

import { Toast } from "mint-ui";

export default {
  name: "order",
  data() {
    return {
      appid: null,
      key: null,
      selectStatus: "阳澄湖大闸蟹",
      tipShow: false,
      errorMsg: "",
      prices: 0.01
    };
  },
  components: {
    // New,
    payforList,
    goodInfo
  },
  created() {},
  mounted() {},
  methods: {
    putorder() {
      let config = {
        myapp_id: this.appid
      };
      let _this = this;
      // 65-90
      // 97-122
      httpApi.cashierMsg(config).then(res => {
        if (res.status == 200) {
          if (res.data.channel.length > 0) {
            _this.tipShow = false;
            _this.$router.push({
              path: "/cashPage",
              query: {
                myapp_id: _this.appid,
                key: _this.key,
                total_amount: _this.prices * 100,
                out_trade_no: +new Date(),
                subject: escape(this.selectStatus),
                nonce_str: _this.getStrSign(),
                sign: _this.getStrSign(),
                time_stamp: +new Date(),
                product_id: 10087972,
                order_amount: _this.prices * 100,
                extra_amount: 0,
                discount_amount: 0,
                goodInfo: escape(_this.selectStatus)
              }
            });
          } else {
            _this.errorMsg = res.msg;
            _this.tipShow = true;
          }
        } else {
          _this.errorMsg = res.msg;
          _this.tipShow = true;
        }
      });
    },
    tip() {
      this.tipShow = false;
    },
    getStrSign() {
      let strs = [];
      let stra = "";
      for (let i = 65; i <= 90; i++) {
        strs.push(i);
      }
      for (let i = 97; i <= 122; i++) {
        strs.push(i);
      }
      for (let i = 0; i < 32; i++) {
        // let ele = array[i];
        let num = Math.floor(Math.random() * strs.length);
        stra += String.fromCharCode(strs[num]);
      }
      return stra;
    }
  }
};
// .mint-switch-input:checked + .mint-switch-core



// WEBPACK FOOTER //
// ./src/components/order/index.vue